import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');


const RenderRestartAws = () => {

/*
console.log("session.AW_USERNAME "+sessionStorage.getItem("AW_USERNAME"));
console.log("session.REST_URL "+sessionStorage.getItem("REST_URL"));

if (!sessionStorage.getItem("AW_USERNAME")){
	console.log("will set AW_USERNAME to session");
	sessionStorage.setItem("AW_USERNAME", "ajones");
	sessionStorage.setItem("REST_URL", "http://localhost:3001/");
	}
*/

const resturl=sessionStorage.getItem("REST_URL");


const navigate = useNavigate();



const [tblautorestart, setTblautorestart] = useState([]);
const [tbltaskeventlog, setTbltaskeventlog] = useState([]);

const [crit, setCrit] = useState({date1:''});
const [taskeventlog, setTaskeventlog] = useState({show:false});
const [timestamps, setTimestamps] = useState({client:'', server:''});

const [dowait, setDowait] = useState({show:false});




const location = useLocation();


useEffect(() => {

let date1 = new Date().toISOString().slice(0, 10);
	setCrit((prev)=>{
		return {...prev, date1:date1}
	});

 },[]);


useEffect(() => {

if (crit.date1=="")
	return;

console.log("date1: "+crit.date1);
getautorestart();
if (timestamps.client=="")
	comparetimestamps();

 },[crit.date1]);


useEffect(() => {

if (taskeventlog.show==true && tbltaskeventlog.length==0)
	gettaskeventlog();
	
 },[taskeventlog.show]);



async function comparetimestamps(){
	
	const timestamp= new Date().toLocaleString("en-US", {timeZone: "Pacific/Easter"});
	

	const requestOptions = {
	method: 'POST'
	,headers: { 'Content-Type': 'application/json' }
	,body: JSON.stringify( {timestamp:timestamp} )
	};
	

	
	await fetch(resturl+'rarsad/comparetimestamps',requestOptions)
	.then(res => res.json())
	.then(res => aftercomparetimestamps(res))
	.catch(err => console.log(err));

}//end func

function aftercomparetimestamps(res){
	console.log("aftercomparetimestamps: "+JSON.stringify(res));
	setTimestamps({
		client:res[0].CLIENT_TIMESTAMP
		, server:res[0].SERVER_TIMESTAMP
	});
}//end func

async function setautorestart(e){
	
	const result=window.confirm("are you sure?");
	if (!result)
		return;
	
	const params={
	username: sessionStorage.getItem("AW_USERNAME")
	}//end function


	const requestOptions = {
	method: 'POST'
	,headers: { 'Content-Type': 'application/json' }
	,body: JSON.stringify( params )
	};
	
	setDowait({show:true});
	
	await fetch(resturl+'rarsad/setautorestart',requestOptions)
	.then(res => res.json())
	.then(res => aftersetautorestart(res))
	.catch(err => console.log(err));

}//end func

function aftersetautorestart(res){
	setDowait({show:false});
	
	let UPDATE_COUNT=0;
	if (res.length)
		if (res.length>0)
			UPDATE_COUNT=res[0].UPDATE_COUNT;
		
	if (UPDATE_COUNT==0)
		showsnackbar("that failed!  make sure to wait 120 minutes between restart");
	else
		showsnackbar("done!");
	
	getautorestart();
}//end func

async function getautorestart(){
	const params={
	date1: crit.date1
	}//end function


	const requestOptions = {
	method: 'POST'
	,headers: { 'Content-Type': 'application/json' }
	,body: JSON.stringify( params )
	};

setDowait({show:true});

	await fetch(resturl+'rarsad/getautorestart',requestOptions)
	.then(res => res.json())
	.then(res => aftergetautorestart(res))
	.catch(err => console.log(err));

}//end func

function aftergetautorestart(res){

setDowait({show:false});

if (!res.length){
	setTblautorestart(<tr><td colSpan="5" align="center" >no records</td></tr>);
	return;
	}

let htmrows=[];

res.map((col, index) => {
		const key="aftergetautorestart_tr"+index;
		
		const BETWEENTIME=col['BETWEENTIME']==null?"":col['BETWEENTIME']+" Mins";
		
		htmrows.push(<>
		<tr>
		<td align="right" >{1+index}</td>
		<td align="center" >{col['USERNAME']}</td>
		<td align="center" >{col['SERVERSTART']}</td>
		<td align="center" >{col['TC_AUTORESTART']}</td>
		<td align="center" >{col['EMAILSENT']}</td>
		<td align="center" >{col['SHUTDOWNSTART']}</td>
		<td align="center" >{col['SHUTDOWNCOMPLETE']}</td>
		<td align="center" >{BETWEENTIME}</td>
		</tr>
		</>
		);


	});//end map


console.log('aftergetautorestart htmrows: '+htmrows.length);
setTblautorestart(htmrows);
	
}//end func


async function gettaskeventlog(){
	const params={
	date1: crit.date1
	}//end function


	const requestOptions = {
	method: 'POST'
	,headers: { 'Content-Type': 'application/json' }
	,body: JSON.stringify( params )
	};

setDowait({show:true});

	await fetch(resturl+'rarsad/gettaskeventlog',requestOptions)
	.then(res => res.json())
	.then(res => aftergettaskeventlog(res))
	.catch(err => console.log(err));

}//end func

function aftergettaskeventlog(res){

setDowait({show:false});

if (!res.length){
	setTbltaskeventlog(<tr><td colSpan="5" align="center" >no records</td></tr>);
	return;
	}

let htmrows=[];

res.map((col, index) => {
		const key="aftergettaskeventlog_tr"+index;
		
		
		htmrows.push(<>
		<tr>
		<td align="right" >{1+index}</td>
		<td align="center" >{col['STAMP']}</td>
		<td align="center" >{col['DONE']}</td>
		<td align="center" >{col['HRS']}</td>
		</tr>
		</>
		);


	});//end map


console.log('aftergettaskeventlog htmrows: '+htmrows.length);
setTbltaskeventlog(htmrows);
	
}//end func




function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func


function handleChange(e){
	
	const {name, value}=e.target;
	setCrit((prev)=>{
		return {...prev, [name]:value}
	});
}//end func

function callSetTaskeventlog(e){
	
	setTaskeventlog({show:e.target.checked});
	
	document.getElementById('cbtaskeventlog').checked=e.target.checked;
	
}//end func

  return (
    <>

		<div align='center' style={{marginTop:"18px"}}>Table of Requests to Restart Asycuda Server</div>
		
		<div align='center' style={{marginTop:"9px"}} >
			Date:<input type="date" name="date1" value={crit.date1} onChange={(e)=>{handleChange(e);}} />
		</div>
		
		<div align='center' style={{marginTop:"9px"}} >
			<button className="button" onClick={(e)=>{setautorestart(e);}} >add a new request to restart</button>
		</div>
	
		{dowait.show && <><div align="center" ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div></> }
		{!dowait.show && <>
		<table align="center" className="customers"  style={{width:"70%", marginTop:"18px"}} cellSpacing="0" cellPadding="0" >
		<thead>
		<tr>		
		<th>#</th>
		<th>Username</th>
		<th>Server Start</th>
		<th>Restart Requested</th>
		<th>Email Sent</th>
		<th>Shutdown Start</th>
		<th>Shutdown Done</th>
		<th>Time taken</th>
		</tr>		
		</thead>

		<tbody>
		{tblautorestart}
		</tbody>
		</table>
		
		<table align="center" width="50%" style={{marginTop:"18px"}} >
		<tbody>
		<tr>
			<td align="right" >time according to Pacific/Easter time zone:</td>
			<td align="left" >{timestamps.client}</td>
		</tr>
		<tr>
			<td align="right" >time according to Asycuda's Oracle Database:</td>
			<td align="left" >{timestamps.server}</td>
		</tr>
		</tbody>
		</table>		
		
		<div align='center' style={{marginTop:"18px"}} >
		<input type='checkbox'   id='cbtaskeventlog' checked={taskeventlog.show}  onChange={(e)=>{callSetTaskeventlog(e);}} /><label htmlFor='cbtaskeventlog' className="hand" >Show Task Event Log</label>
		</div>
		
		{
		taskeventlog.show==true && 
		<table align="center" className="customers"  style={{width:"70%"}} cellSpacing="0" cellPadding="0" >
		<thead>
		<tr>		
		<th>#</th>
		<th>Stamp</th>
		<th>Done</th>
		<th>Hrs</th>
		</tr>		
		</thead>

		<tbody>
		{tbltaskeventlog}
		</tbody>
		</table>		
		}
		
		</>
		}
		
		<div id="snackbar" ></div>
    </>
  );
  


};


export default RenderRestartAws;